import { HTTP_CP_SmartSearchCase } from '@api-new/caseservice';
import { HTTP_CP_SmartSearch, HTTP_CP_SmartSearchDeal } from '@api-new/mortgageservice';
import { Dictionary } from '@ngrx/entity';
import { PortfolioSmartSearch } from '@platform/smart-search/models/smart-search.model';
import { PropertyMortgageSelectItem } from '@shared-lib/models/property-mortgage-select-item.model';
import { buildPortfolioCasePreviewCard } from './portfolio-case-preview-card.adapter';

export const portfolioSmartSearchAdapter = (
  smartSearch: HTTP_CP_SmartSearch,
  smartSearchDealEntities: SmartSearchDealEntitiesType,
  smartSearchCases: HTTP_CP_SmartSearchCase[],
  propertyMortgageSelectItems: PropertyMortgageSelectItem[],
): PortfolioSmartSearch => {
  const smartSearchDealEntity = smartSearchDealEntities[smartSearch.id];
  const smartSearchCase = smartSearchCases.find((smartSearchCase) => smartSearchCase.smartSearchId === smartSearch.id);
  const casePreviewCard = buildPortfolioCasePreviewCard(smartSearchCase, smartSearchDealEntity?.numberOfSmartSearchDeals);

  const propertyId = getPropertyIdFromSmartSearch(smartSearch);
  const propertyMortgage = getPropertyMortgageByPropId(propertyId, propertyMortgageSelectItems);

  return {
    ...smartSearch,
    deals: smartSearchDealEntity?.smartSearchDeals,
    smartSearchCase,
    casePreviewCard,
    propertyMortgage,
  };
};

// ------ HELPERS -----
const getPropertyIdFromSmartSearch = (smartSearch: HTTP_CP_SmartSearch): string =>
  smartSearch.forRemortgageBorrowMore?.propertyId ||
  smartSearch.forRemortgagePayFaster?.propertyId ||
  smartSearch.forMortgageProduct?.propertyId;

const getPropertyMortgageByPropId = (propertyId, propertyMortgageSelectItems: PropertyMortgageSelectItem[]): PropertyMortgageSelectItem =>
  propertyId ? propertyMortgageSelectItems.find((propertyMortgage) => propertyMortgage.propertyId === propertyId) : null;

// ------ TYPES -----
type SmartSearchDealEntitiesType = Dictionary<{
  smartSearchId: string;
  smartSearchDeals: HTTP_CP_SmartSearchDeal[];
  numberOfSmartSearchDeals?: number;
}>;
